/**
 * @generated SignedSource<<f1b7721a1251b00c575fb90b3a2e6daa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditFeedbackPopoverFeedbackHistory_todoFeedback$data = ReadonlyArray<{
  readonly body: string | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineFeedback_feedback">;
  readonly " $fragmentType": "TodoEditFeedbackPopoverFeedbackHistory_todoFeedback";
}>;
export type TodoEditFeedbackPopoverFeedbackHistory_todoFeedback$key = ReadonlyArray<{
  readonly " $data"?: TodoEditFeedbackPopoverFeedbackHistory_todoFeedback$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditFeedbackPopoverFeedbackHistory_todoFeedback">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoEditFeedbackPopoverFeedbackHistory_todoFeedback",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoTimelineFeedback_feedback"
    }
  ],
  "type": "TodoFeedback",
  "abstractKey": null
};

(node as any).hash = "bd3bc01210ff0fba4aba5b26f36a6b9a";

export default node;
